<template>
    <!-- Sidebar -->
    <aside :class="expanded ? 'tw:w-70' : 'tw:w-20'"
        class="tw:h-screen tw:bg-brand-background tw:text-slate-300 tw:flex tw:flex-col tw:fixed tw:top-0 tw:left-0 tw:z-40 tw:shadow-xl tw:select-none tw:transition-[width] tw:duration-300"
        @mouseenter="setSidebarHovering(true)" @mouseleave="setSidebarHovering(false)">

        <!-- Sidebar Brand Logo -->
        <div class="tw:flex tw:items-center tw:gap-3 tw:border-b tw:border-brand-background/80 tw:bg-brand-background/50 tw:transition-all tw:duration-300 tw:shadow-lg"
            :class="expanded ? 'tw:h-40 tw:px-5' : 'tw:h-20 tw:px-2'">
            <router-link to="/admin/dashboard"
                class="tw:flex tw:justify-center tw:flex-col tw:items-center tw:gap-3 tw:no-underline tw:w-full">
                <div :class="expanded ? 'tw:w-26 tw:h-26' : 'tw:w-16 tw:h-16'"
                    class="tw:rounded-xl tw:bg-brand-background/20 tw:border tw:border-primary/30 tw:flex tw:items-center tw:justify-center tw:overflow-hidden tw:shrink-0 tw:transition-all tw:duration-300">
                    <img src="/img/aliht.png" :alt="config.name || 'Logo'"
                        class="tw:w-full tw:h-full tw:object-cover tw:p-2 img-fluid" />
                </div>
                <span v-show="expanded" class="tw:font-bold tw:text-lg tw:text-slate-100 tw:truncate tw:tracking-tight">
                    {{ config.name || 'Panel Admin' }}
                </span>
            </router-link>
        </div>

        <!-- Scrollable Navigation -->
        <div class="tw:flex-1 tw:overflow-hidden" v-if="showMenus">
            <div class="scroll-area tw:py-2">
                <nav id="sidebar-menu" class="tw:p-3 tw:space-y-2">

                    <!-- Home -->
                    <div v-if="ACCESS_MENU(MENU_HOME)">
                        <router-link to="/admin/dashboard"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': currentPath == ROUTE_HOME }">
                            <i :class="ACCESS_MENU(MENU_HOME).menu.icon" class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_HOME).menu.title }}</span>
                        </router-link>
                    </div>

                    <!-- Agencias -->
                    <div v-if="ACCESS_MENU(MENU_AGENCY)">
                        <router-link to="/admin/agencias"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_AGENCIES, ROUTE_AGENCIESADD, ROUTE_AGENCIESEDIT, ROUTE_AGENCIES_COMMISSIONS].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_AGENCY).menu.icon" class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_AGENCY).menu.title }}</span>
                        </router-link>
                    </div>

                    <!-- Operadoras -->
                    <div v-if="ACCESS_MENU(MENU_OPERATORS)">
                        <router-link to="/admin/operadoras"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_OPERATORS, ROUTE_OPERATOR_ADD, ROUTE_OPERATOR_EDIT].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_OPERATORS).menu.icon"
                                class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_OPERATORS).menu.title
                                }}</span>
                        </router-link>
                    </div>

                    <!-- Transportadoras -->
                    <div v-if="ACCESS_MENU(MENU_CONVEYORS)">
                        <router-link to="/admin/transportadoras"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_TRANSPORTS, ROUTE_TRANSPORT_ADD, ROUTE_TRANSPORT_EDIT].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_CONVEYORS).menu.icon"
                                class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_CONVEYORS).menu.title
                                }}</span>
                        </router-link>
                    </div>

                    <!-- Unidades -->
                    <div v-if="ACCESS_MENU(MENU_UNITS)">
                        <router-link to="/admin/unidades"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_UNITS].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_UNITS).menu.icon" class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_UNITS).menu.title }}</span>
                        </router-link>
                    </div>

                    <!-- Servicios (submenu) -->
                    <div v-if="ACCESS_MENU(MENU_SERVICES)" class="tw:relative tw:space-y-1">
                        <button type="button" @click="toggleMenu(1)"
                            class="tw:w-full tw:flex tw:items-center tw:justify-between tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:bg-transparent tw:border-0 tw:cursor-pointer tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{
                                'tw:bg-primary/15 tw:text-primary tw:font-semibold': [
                                    ROUTE_SERVICE_HOTELS, ROUTE_SERVICE_CIRCUITS, ROUTE_SERVICE_DAYTRIPS, ROUTE_SERVICE_TOURS,
                                    ROUTE_SERVICE_INTERNATIONALS, ROUTE_SERVICE_ADD, ROUTE_SERVICE_EDIT, ROUTE_SERVICE_TRAVEL_DATE,
                                    ROUTE_SERVICE_EXIT_PLACES, ROUTE_SERVICE_EXIT_PLACE_PRICES, ROUTE_SERVICE_LOCKEDS, ROUTE_SERVICE_ADD_LOCKED, ROUTE_SERVICE_EDIT_LOCKED,
                                    ROUTE_SERVICE_GROUPS, ROUTE_SERVICE_ADD_GROUP,
                                ].includes(currentPath)
                            }">
                            <div class="tw:flex tw:items-center tw:gap-3">
                                <i :class="ACCESS_MENU(MENU_SERVICES).menu.icon"
                                    class="tw:text-sm tw:w-4 tw:text-center"></i>
                                <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_SERVICES).menu.title
                                    }}</span>
                            </div>
                            <i v-if="expanded"
                                class="fas fa-chevron-right tw:text-sm tw:text-slate-500 tw:transition-transform tw:duration-200"
                                :class="{ 'tw:rotate-90': openMenu && menuActive == 1 }"></i>
                        </button>
                        <div v-show="openMenu && menuActive == 1" class="tw:pl-9 tw:pr-2 tw:py-1 tw:space-y-1">
                            <router-link to="/admin/servicios/hoteles"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_SERVICE_HOTELS].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Hoteles
                            </router-link>
                            <router-link to="/admin/servicios/circuitos"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_SERVICE_CIRCUITS].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Circuitos
                            </router-link>
                            <router-link to="/admin/servicios/pasadias"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_SERVICE_DAYTRIPS].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Pasadias
                            </router-link>
                            <router-link to="/admin/servicios/tours"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_SERVICE_TOURS].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Tours
                            </router-link>
                            <router-link to="/admin/servicios/internacionales"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_SERVICE_INTERNATIONALS].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Internacionales
                            </router-link>
                            <router-link to="/admin/servicios/bloqueos"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_SERVICE_LOCKEDS, ROUTE_SERVICE_ADD_LOCKED, ROUTE_SERVICE_EDIT_LOCKED].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Bloqueos
                            </router-link>
                            <router-link to="/admin/servicios/grupos"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_SERVICE_GROUPS, ROUTE_SERVICE_ADD_GROUP].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Grupos
                            </router-link>
                        </div>
                    </div>

                    <!-- Cotizador -->
                    <div v-if="ACCESS_MENU(MENU_QUOTE)">
                        <router-link to="/admin/cotizador"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_SERVICE_QUOTE].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_QUOTE).menu.icon" class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_QUOTE).menu.title }}</span>
                        </router-link>
                    </div>

                    <!-- Reservaciones (submenu) -->
                    <div v-if="ACCESS_MENU(MENU_RESERVATIONS)" class="tw:relative tw:space-y-1">
                        <button type="button" @click="toggleMenu(2)"
                            class="tw:w-full tw:flex tw:items-center tw:justify-between tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:bg-transparent tw:border-0 tw:cursor-pointer tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{
                                'tw:bg-primary/15 tw:text-primary tw:font-semibold': [
                                    ROUTE_RESERVATION_HOTEL_INDEX, ROUTE_RESERVATION_HOTEL_SHOW,
                                    ROUTE_RESERVATION_CIRCUIT_INDEX, ROUTE_RESERVATION_CIRCUIT_SHOW,
                                    ROUTE_RESERVATION_DAYTRIPS_INDEX, ROUTE_RESERVATION_DAYTRIPS_SHOW,
                                    ROUTE_RESERVATION_TOURS_INDEX, ROUTE_RESERVATION_TOURS_SHOW,
                                    ROUTE_RESERVATION_INTERNATIONALS_INDEX, ROUTE_RESERVATION_INTERNATIONALS_SHOW,
                                    ROUTE_RESERVATION_FLIGHTS_INDEX, ROUTE_RESERVATION_FLIGHTS_SHOW,
                                    ROUTE_RESERVATION_OTHER_SERVICE_INDEX, ROUTE_RESERVATION_OTHER_SERVICE_SHOW,
                                    ROUTE_RESERVATION_TRANSFER_INDEX, ROUTE_RESERVATION_TRANSFER_SHOW,
                                    ROUTE_RESERVATION_PACKAGED_INDEX, ROUTE_RESERVATION_PACKAGED_SHOW,
                                    ROUTE_RESERVATION_PAYMENT_TO_BROOKER,
                                    ROUTE_RESERVATION_LOCKED_INDEX, ROUTE_RESERVATION_LOCKED_SHOW,
                                    ROUTE_RESERVATION_GROUP_INDEX, ROUTE_RESERVATION_GROUP_SHOW,
                                ].includes(currentPath)
                            }">
                            <div class="tw:flex tw:items-center tw:gap-3">
                                <i :class="ACCESS_MENU(MENU_RESERVATIONS).menu.icon"
                                    class="tw:text-sm tw:w-4 tw:text-center"></i>
                                <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_RESERVATIONS).menu.title
                                    }}</span>
                            </div>
                            <i v-if="expanded"
                                class="fas fa-chevron-right tw:text-sm tw:text-slate-500 tw:transition-transform tw:duration-200"
                                :class="{ 'tw:rotate-90': openMenu && menuActive == 2 }"></i>
                        </button>
                        <div v-show="openMenu && menuActive == 2" class="tw:pl-9 tw:pr-2 tw:py-1 tw:space-y-1">
                            <router-link to="/admin/reservaciones/hoteles"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_HOTEL_INDEX, ROUTE_RESERVATION_HOTEL_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Hoteles
                            </router-link>
                            <router-link to="/admin/reservaciones/circuitos"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_CIRCUIT_INDEX, ROUTE_RESERVATION_CIRCUIT_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Circuitos
                            </router-link>
                            <router-link to="/admin/reservaciones/pasadias"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_DAYTRIPS_INDEX, ROUTE_RESERVATION_DAYTRIPS_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Pasadias
                            </router-link>
                            <router-link to="/admin/reservaciones/tours"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_TOURS_INDEX, ROUTE_RESERVATION_TOURS_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Tours
                            </router-link>
                            <router-link to="/admin/reservaciones/internacionales"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_INTERNATIONALS_INDEX, ROUTE_RESERVATION_INTERNATIONALS_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Internacionales
                            </router-link>
                            <router-link to="/admin/reservaciones/vuelos"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_FLIGHTS_INDEX, ROUTE_RESERVATION_FLIGHTS_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Vuelos
                            </router-link>
                            <router-link to="/admin/reservaciones/otros-servicios"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_OTHER_SERVICE_INDEX, ROUTE_RESERVATION_OTHER_SERVICE_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Otros Servicios
                            </router-link>
                            <router-link to="/admin/reservaciones/empaquetados"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_PACKAGED_INDEX, ROUTE_RESERVATION_PACKAGED_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Empaquetados
                            </router-link>
                            <router-link to="/admin/reservaciones/traslados"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_TRANSFER_INDEX, ROUTE_RESERVATION_TRANSFER_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Traslados
                            </router-link>
                            <router-link to="/admin/reservaciones/bloqueos"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_LOCKED_INDEX, ROUTE_RESERVATION_LOCKED_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Bloqueos
                            </router-link>
                            <router-link to="/admin/reservaciones/grupos"
                                class="tw:block tw:py-1.5 tw:px-3 tw:rounded-lg tw:text-sm tw:text-slate-300 tw:no-underline tw:transition-colors tw:hover:text-slate-200 tw:hover:bg-slate-800/40"
                                :class="{ 'tw:text-primary tw:font-semibold tw:bg-primary/10': [ROUTE_RESERVATION_GROUP_INDEX, ROUTE_RESERVATION_GROUP_SHOW].includes(currentPath) }">
                                <i class="fa fa-hashtag tw:mr-2"></i> Grupos
                            </router-link>
                        </div>
                    </div>

                    <!-- Promociones -->
                    <div v-if="ACCESS_MENU(MENU_PROMOTIONS)">
                        <router-link to="/admin/promociones"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_PROMOTIONS, ROUTE_PROMOTION_ADD, ROUTE_PROMOTION_EDIT].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_PROMOTIONS).menu.icon"
                                class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_PROMOTIONS).menu.title
                                }}</span>
                        </router-link>
                    </div>

                    <!-- Pagos en efectivo -->
                    <div v-if="ACCESS_MENU(MENU_CASH_PAYMENT)">
                        <router-link to="/admin/pagos-efectivo"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_CASH_PAYMENT].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_CASH_PAYMENT).menu.icon"
                                class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_CASH_PAYMENT).menu.title
                                }}</span>
                        </router-link>
                    </div>

                    <!-- Pagos por confirmar -->
                    <div v-if="ACCESS_MENU(MENU_PENDING_PAYMENTS)">
                        <router-link to="/admin/pagos-por-confirmar"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_PENDING_PAYMENTS].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_PENDING_PAYMENTS).menu.icon"
                                class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_PENDING_PAYMENTS).menu.title
                                }}</span>
                        </router-link>
                    </div>

                    <!-- Cuentas / Bancos -->
                    <div v-if="ACCESS_MENU(MENU_BANKS)">
                        <router-link to="/admin/cuentas"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_BANKS, ROUTE_BANK_ADD, ROUTE_BANK_EDIT].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_BANKS).menu.icon" class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_BANKS).menu.title }}</span>
                        </router-link>
                    </div>

                    <!-- Administradores -->
                    <div v-if="ACCESS_MENU(MENU_USERS)">
                        <router-link to="/admin/administradores"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_USER_ADMIN, ROUTE_USER_ADD, ROUTE_USER_EDIT, ROUTE_USER_NOTIFICATIONS].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_USERS).menu.icon" class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_USERS).menu.title }}</span>
                        </router-link>
                    </div>

                    <!-- Perfiles -->
                    <div v-if="ACCESS_MENU(MENU_PROFILES)">
                        <router-link to="/admin/perfiles"
                            class="tw:flex tw:items-center tw:gap-3 tw:px-3.5 tw:py-2.5 tw:rounded-xl tw:text-sm tw:font-medium tw:text-slate-300 tw:no-underline tw:transition-all tw:hover:bg-slate-800/70 tw:hover:text-slate-200"
                            :class="{ 'tw:bg-primary/15 tw:text-primary tw:font-semibold': [ROUTE_PROFILE_LIST, ROUTE_PROFILE_ADD, ROUTE_PROFILE_EDIT].includes(currentPath) }">
                            <i :class="ACCESS_MENU(MENU_PROFILES).menu.icon"
                                class="tw:text-sm tw:w-4 tw:text-center"></i>
                            <span class="tw:truncate" v-show="expanded">{{ ACCESS_MENU(MENU_PROFILES).menu.title
                                }}</span>
                        </router-link>
                    </div>
                </nav>
            </div>
        </div>
    </aside>
    <!-- /Sidebar -->
</template>

<script>
import {
    MENU_HOME, MENU_AGENCY, MENU_OPERATORS, MENU_CONVEYORS, MENU_UNITS, MENU_SERVICES, MENU_RESERVATIONS,
    MENU_USERS, MENU_PROMOTIONS, MENU_BANKS, MENU_PROFILES, MENU_CASH_PAYMENT, MENU_PENDING_PAYMENTS, MENU_QUOTE
} from "@/enums/MenuEnums";
import {
    ROUTE_HOME,
    ROUTE_AGENCIES,
    ROUTE_AGENCIESADD,
    ROUTE_AGENCIESEDIT,
    ROUTE_AGENCIES_COMMISSIONS,
    ROUTE_USER_ADMIN,
    ROUTE_USER_ADD,
    ROUTE_USER_EDIT,
    ROUTE_OPERATORS,
    ROUTE_OPERATOR_ADD,
    ROUTE_OPERATOR_EDIT,
    ROUTE_TRANSPORTS,
    ROUTE_TRANSPORT_ADD,
    ROUTE_TRANSPORT_EDIT,
    ROUTE_UNITS,
    ROUTE_SERVICE_HOTELS,
    ROUTE_SERVICE_CIRCUITS,
    ROUTE_SERVICE_DAYTRIPS,
    ROUTE_SERVICE_TOURS,
    ROUTE_SERVICE_INTERNATIONALS,
    ROUTE_SERVICE_LOCKEDS,
    ROUTE_SERVICE_ADD_LOCKED,
    ROUTE_SERVICE_EDIT_LOCKED,
    ROUTE_SERVICE_GROUPS,
    ROUTE_SERVICE_ADD_GROUP,
    ROUTE_SERVICE_ADD,
    ROUTE_SERVICE_EDIT,
    ROUTE_SERVICE_TRAVEL_DATE,
    ROUTE_SERVICE_EXIT_PLACES,
    ROUTE_SERVICE_EXIT_PLACE_PRICES,
    ROUTE_RESERVATION_HOTEL_INDEX,
    ROUTE_RESERVATION_HOTEL_SHOW,
    ROUTE_RESERVATION_CIRCUIT_INDEX,
    ROUTE_RESERVATION_CIRCUIT_SHOW,
    ROUTE_RESERVATION_DAYTRIPS_INDEX,
    ROUTE_RESERVATION_DAYTRIPS_SHOW,
    ROUTE_RESERVATION_INTERNATIONALS_INDEX,
    ROUTE_RESERVATION_INTERNATIONALS_SHOW,
    ROUTE_RESERVATION_FLIGHTS_INDEX,
    ROUTE_RESERVATION_FLIGHTS_SHOW,
    ROUTE_RESERVATION_OTHER_SERVICE_INDEX,
    ROUTE_RESERVATION_OTHER_SERVICE_SHOW,
    ROUTE_RESERVATION_TOURS_INDEX,
    ROUTE_RESERVATION_TOURS_SHOW,
    ROUTE_PROFILE_LIST,
    ROUTE_PROFILE_ADD,
    ROUTE_BANKS,
    ROUTE_BANK_ADD,
    ROUTE_BANK_EDIT,
    ROUTE_PROFILE_EDIT,
    ROUTE_PROMOTIONS,
    ROUTE_PROMOTION_ADD,
    ROUTE_PROMOTION_EDIT,
    ROUTE_RESERVATION_PAYMENT_TO_BROOKER,
    ROUTE_USER_NOTIFICATIONS,
    ROUTE_CASH_PAYMENT,
    ROUTE_PENDING_PAYMENTS,
    ROUTE_RESERVATION_TRANSFER_INDEX,
    ROUTE_RESERVATION_TRANSFER_SHOW,
    ROUTE_RESERVATION_PACKAGED_INDEX,
    ROUTE_RESERVATION_PACKAGED_SHOW,
    ROUTE_SERVICE_QUOTE,
    ROUTE_RESERVATION_LOCKED_INDEX,
    ROUTE_RESERVATION_LOCKED_SHOW,
    ROUTE_RESERVATION_GROUP_INDEX,
    ROUTE_RESERVATION_GROUP_SHOW,
} from "@/enums/RouteNameEnums";
import { mapGetters } from "vuex";
import { ACCESS_MENU } from "@/validations/auth/AccessControlList";
import { isSidebarCollapsed, isSidebarEffectivelyCollapsed, setSidebarHovering } from '@/plugins/sidebarStore';

export default {
    data() {
        return {
            config: {},
            showMenus: false,
            activeClass: 'active',
            openMenu: true,
            menuActive: 0,

            //MENU IDS
            MENU_HOME, MENU_AGENCY,
            MENU_OPERATORS, MENU_CONVEYORS,
            MENU_UNITS, MENU_SERVICES, MENU_RESERVATIONS,
            MENU_USERS, MENU_PROMOTIONS, MENU_BANKS, MENU_PROFILES, MENU_CASH_PAYMENT,
            MENU_PENDING_PAYMENTS, MENU_QUOTE,

            //ROUTE NAMES COMPONENTS
            ROUTE_HOME,
            ROUTE_AGENCIES,
            ROUTE_AGENCIESADD,
            ROUTE_AGENCIESEDIT,
            ROUTE_AGENCIES_COMMISSIONS,
            ROUTE_USER_ADMIN,
            ROUTE_USER_ADD,
            ROUTE_USER_EDIT,
            ROUTE_OPERATORS,
            ROUTE_OPERATOR_ADD,
            ROUTE_OPERATOR_EDIT,
            ROUTE_TRANSPORTS,
            ROUTE_TRANSPORT_ADD,
            ROUTE_TRANSPORT_EDIT,
            ROUTE_UNITS,
            ROUTE_SERVICE_HOTELS,
            ROUTE_SERVICE_CIRCUITS,
            ROUTE_SERVICE_DAYTRIPS,
            ROUTE_SERVICE_TOURS,
            ROUTE_SERVICE_INTERNATIONALS,
            ROUTE_SERVICE_LOCKEDS,
            ROUTE_SERVICE_ADD_LOCKED,
            ROUTE_SERVICE_EDIT_LOCKED,
            ROUTE_SERVICE_GROUPS,
            ROUTE_SERVICE_ADD_GROUP,
            ROUTE_SERVICE_ADD,
            ROUTE_SERVICE_EDIT,
            ROUTE_SERVICE_TRAVEL_DATE,
            ROUTE_SERVICE_EXIT_PLACES,
            ROUTE_SERVICE_EXIT_PLACE_PRICES,
            ROUTE_RESERVATION_HOTEL_INDEX,
            ROUTE_RESERVATION_HOTEL_SHOW,
            ROUTE_RESERVATION_CIRCUIT_INDEX,
            ROUTE_RESERVATION_CIRCUIT_SHOW,
            ROUTE_RESERVATION_DAYTRIPS_INDEX,
            ROUTE_RESERVATION_DAYTRIPS_SHOW,
            ROUTE_RESERVATION_INTERNATIONALS_INDEX,
            ROUTE_RESERVATION_INTERNATIONALS_SHOW,
            ROUTE_RESERVATION_FLIGHTS_INDEX,
            ROUTE_RESERVATION_FLIGHTS_SHOW,
            ROUTE_RESERVATION_OTHER_SERVICE_INDEX,
            ROUTE_RESERVATION_OTHER_SERVICE_SHOW,
            ROUTE_RESERVATION_TOURS_INDEX,
            ROUTE_RESERVATION_TOURS_SHOW,
            ROUTE_PROFILE_LIST,
            ROUTE_PROFILE_ADD,
            ROUTE_BANKS,
            ROUTE_BANK_ADD,
            ROUTE_BANK_EDIT,
            ROUTE_PROFILE_EDIT,
            ROUTE_PROMOTIONS,
            ROUTE_PROMOTION_ADD,
            ROUTE_PROMOTION_EDIT,
            ROUTE_RESERVATION_PAYMENT_TO_BROOKER,
            ROUTE_USER_NOTIFICATIONS,
            ROUTE_CASH_PAYMENT,
            ROUTE_PENDING_PAYMENTS,
            ROUTE_RESERVATION_TRANSFER_INDEX,
            ROUTE_RESERVATION_TRANSFER_SHOW,
            ROUTE_RESERVATION_PACKAGED_INDEX,
            ROUTE_RESERVATION_PACKAGED_SHOW,
            ROUTE_SERVICE_QUOTE,
            ROUTE_RESERVATION_LOCKED_INDEX,
            ROUTE_RESERVATION_LOCKED_SHOW,
            ROUTE_RESERVATION_GROUP_INDEX,
            ROUTE_RESERVATION_GROUP_SHOW,
        };
    },
    computed: {
        ...mapGetters("auth", ["user"]),
        ...mapGetters("config", ["configuration"]),

        currentPath() {
            return this.$route.name;
        },
        collapsed() {
            return isSidebarCollapsed();
        },
        expanded() {
            return !isSidebarEffectivelyCollapsed();
        }
    },
    mounted() {
        setTimeout(() => {
            const config = JSON.parse(localStorage.getItem('configuration'));
            if (config !== undefined && config !== null) {
                this.config = config;
            }
            this.showMenus = true;
            this.$nextTick(() => {
                this.scrollAreaEl = this.$el.querySelector('.scroll-area');
                if (this.scrollAreaEl) {
                    this.scrollAreaEl.addEventListener('scroll', this.handleNavScroll);
                }
            });
        }, 2000);
    },
    beforeDestroy() {
        if (this.scrollAreaEl) {
            this.scrollAreaEl.removeEventListener('scroll', this.handleNavScroll);
        }
        clearTimeout(this.navScrollHideTimeout);
    },
    methods: {
        ACCESS_MENU,
        setSidebarHovering,
        // Keeps the nav's own scrollbar invisible at rest; only reveals it
        // while actively scrolling, same treatment as .page-wrapper.
        handleNavScroll() {
            this.scrollAreaEl.classList.add('is-scrolling');
            clearTimeout(this.navScrollHideTimeout);
            this.navScrollHideTimeout = setTimeout(() => {
                this.scrollAreaEl.classList.remove('is-scrolling');
            }, 800);
        },
        toggleMenu(menu) {
            if (menu != this.menuActive && this.openMenu == true) {
                this.menuActive = menu;
                return;
            }

            this.menuActive = menu;
            this.openMenu = !this.openMenu;
        }
    },
}
</script>
<style scoped>
.scroll-area {
    position: relative;
    margin: auto;
    height: calc(100vh - 180px);
    background-color: transparent !important;
}
</style>
